const parseBlockedEmailsConfig = (configStr = "") => {
  const config = {};
  const featurePairs = configStr.split(";");

  featurePairs.forEach((pair) => {
    const [feature, emails] = pair.split(":");
    if (feature && emails) {
      config[feature] = emails.split(",").map((email) => email.trim());
    }
  });

  return config;
};

export const BLOCKED_FEATURES = {
  ALL: "all",
  WPS: {
    PAGE: "wps",
  },
};

const blockedEmailsConfigStr =
  process.env.REACT_APP_BLOCKED_EMAILS_CONFIG || "";
const blockedEmailsConfig = parseBlockedEmailsConfig(blockedEmailsConfigStr);

export const isEmailBlockedForFeature = (featureKey, userEmail) => {
  const blockedEmails = blockedEmailsConfig[featureKey] || [];
  return blockedEmails.includes(userEmail);
};
